/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  getShopURL,
  getShopURLForBrandDeviceType,
  getShopURLForDeviceType,
} from "@utils/urls"
import omit from "lodash/omit"
import React from "react"

const getTransformedMenuData = ({ data, pageContext }) => {
  const { brand, collection, device, deviceType, series } = pageContext
  const filters: any = {}

  const baseFilter = {
    name: "All",
    slug: getShopURL(),
  }

  if (collection) {
    filters.current = collection.name
    filters.previous = baseFilter
    filters.collection = collection
  }

  if (series) {
    filters.current = series.name
    filters.previous = baseFilter
    filters.series = series
  }

  if (device && brand && deviceType) {
    filters.current = device.name
    filters.previous = {
      brand,
      deviceType,
      name: `${brand.name} ${deviceType.name}`,
      slug: getShopURLForBrandDeviceType(brand.slug, deviceType.slug),
    }
    filters.brand = brand
    filters.device = device
    filters.deviceType = deviceType
  } else if (brand && deviceType) {
    filters.current = brand.name
    filters.previous = {
      deviceType,
      name: deviceType.menuLabel || deviceType.name,
      slug: getShopURLForDeviceType(deviceType.slug),
    }
    filters.brand = brand
    filters.deviceType = deviceType
  } else if (deviceType) {
    filters.current = deviceType.menuLabel || deviceType.name
    filters.previous = baseFilter
    filters.deviceType = deviceType
  }

  return {
    ...data,
    filterData: {
      filters,
    },
  }
}

const getCleanedPageContext = ({ pageContext }) => {
  return omit(pageContext, [
    "brand",
    "collection",
    "collectionSlug",
    "device",
    "deviceType",
    "filterFunnel",
    "globalData",
    "menuData",
    "series",
    "seriesSlug",
  ])
}

interface Props {
  data: any
  pageContext: any
}

export default function <A extends Props>(
  WrappedComponent: React.ComponentType<A>
) {
  return (props: A) => {
    const data = React.useMemo(() => getTransformedMenuData(props), [props])
    const pageContext = React.useMemo(
      () => getCleanedPageContext(props),
      [props]
    )

    return <WrappedComponent {...props} data={data} pageContext={pageContext} />
  }
}
